import DeviceData from './DeviceData';
import DeviceItem from './DeviceItem';

function FurnaceDevice(props) {
	return <DeviceItem {...props} data={DeviceData.FURNACE} />;
}

export default FurnaceDevice;
